import { computed, reactive } from 'vue';
import { defineStore } from 'pinia';
import useAppSettingsStore from '@/store/modules/appSettings.js';
import useAuthStore from '@/store/modules/auth.js';
import useLocaleStore from '@/store/modules/locale.js';
import { apiReoptin, apiRequestPinInApp } from '@/services/general.js';

const useIntegrationStore = defineStore('integration', () => {
  const appSettingsStore = useAppSettingsStore();
  const authStore = useAuthStore();
  const localeStore = useLocaleStore();

  const availableIntegrations = reactive({
    ASIACELL_IRAQ: {
      name: 'asiacell_iraq_he',
      info: [],
      transferDigitalParams: false,
      affectsMultiOperator: true,
      storeDigitalParams: true,
      hasExternalRedirection: false,
      hasThirdPartyReSub: true,
      hidePage: false,
      hasConfirmation: false,
      addGraph: true,
      hasAsync: true,
      hasHeReSub: false,
      hasInAppPinRegistration: true,
      hasAsyncKeywordOptin: false,
    },
    IRAQ_ZAIN: {
      name: 'iraq_zain_he',
      info: [],
      transferDigitalParams: false,
      affectsMultiOperator: false,
      storeDigitalParams: true,
      hasExternalRedirection: false,
      hasThirdPartyReSub: false,
      hidePage: false,
      hasConfirmation: false,
      addGraph: false,
      hasAsync: false,
      hasHeReSub: false,
      hasInAppPinRegistration: false,
      hasAsyncKeywordOptin: true,
    },
  });

  const activeIntegration = computed(() => Object.values(availableIntegrations).find(({ name }) => name === appSettingsStore.appProperties.integrationName));
  const hasActiveIntegration = computed(() => !!activeIntegration.value);
  const hasActiveIntegrationAsync = computed(() => hasActiveIntegration.value && !!activeIntegration.value.hasAsync);

  const dispatchIntegrationResubscribeViaWebReoptin = () => {
    switch (appSettingsStore.appProperties.integrationName) {
      case availableIntegrations.ASIACELL_IRAQ.name:
        return apiRequestPinInApp({
          queryParams: {
            msisdn: authStore.user.msisdn,
            lang: localeStore.currentLanguage,
            reoptin: true,
          },
        });
      case availableIntegrations.IRAQ_ZAIN.name:
        return apiRequestPinInApp({
          queryParams: {
            msisdn: authStore.user.msisdn,
            lang: localeStore.currentLanguage,
            webFlow: true,
          },
        });
      default:
        return apiReoptin();
    }
  };

  return {
    availableIntegrations,
    activeIntegration,
    hasActiveIntegration,
    hasActiveIntegrationAsync,
    dispatchIntegrationResubscribeViaWebReoptin,
  };
});

export default useIntegrationStore;
